import { authBinaryFetch, authFetch } from "utils";
import { createUrlParams } from "utils/urlParams";

export const exportXls = (dealIDs) =>
  authBinaryFetch(`${apiUrl}${version}/deals/export/xls`, {
    method: "POST",
    body: JSON.stringify({ deal_ids: dealIDs }),
    headers: {
      "Content-Type": "application/json",
    },
  });

export const exportPdf = (dealIDs, filters) =>
  authFetch(`${apiUrl}${version}/deals/export/pdf`, {
    method: "POST",
    json: { dealIDs, filters },
  });

export const getDeals = (portfolioIDs, status) => {
  const statusParam = status === "all" ? undefined : status;

  return authFetch(
    `${apiUrl}${version}/deals/${createUrlParams({
      portfolio_ids: portfolioIDs,
      status: statusParam,
    })}`,
    {
      method: "GET",
    }
  );
};

export const getDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}`, {
    method: "GET",
  });

export const deleteDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}`, {
    method: "DELETE",
  });

export const saveDeal = (deal) =>
  authFetch(`${apiUrl}${version}/deals/${deal.id}`, {
    method: "PUT",
    json: { deal },
  });

export const createDeal = (deal) =>
  authFetch(`${apiUrl}${version}/deals`, {
    method: "POST",
    json: { deal },
  });

export const reopenDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/reopen`, {
    method: "PATCH",
  });

export const renewDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/duplicate?renew=true`, {
    method: "POST",
  });

export const duplicateDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/duplicate`, {
    method: "POST",
  });

export const disregardDeal = (dealID, disregardFeedback) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/disregard`, {
    method: "PATCH",
    json: disregardFeedback,
  });

export const cancelDeal = (dealID, cancelFeedback) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/cancel`, {
    method: "PATCH",
    json: cancelFeedback,
  });

export const executeDeal = (dealID, details) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/execute`, {
    method: "PATCH",
    json: details,
  });

export const updateDealShareStatus = (dealID, shareStatus, sharedBrokerIds) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/share_status`, {
    method: "PATCH",
    json: { deal: { shareStatus, sharedBrokerIds } },
  });

export const updateDealStage = (dealID, { assetIds, stage }) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/stage`, {
    method: "PATCH",
    json: { deal: { stage, assetIds } },
  });

export const updateDealPointPerson = (dealID, pointPersonId) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}`, {
    method: "PATCH",
    json: { deal: { pointPersonId } },
  });

export const subscribeDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/subscribe`, {
    method: "POST",
  });

export const unsubscribeDeal = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/unsubscribe`, {
    method: "DELETE",
  });
